import { toast } from 'react-hot-toast';
import { ExclamationmarkSmallCircleColorIcon } from '@zep-us/zus';
const TOAST_DURATION = 2000;
function QuoteRestrictionToast({
  message
}: {
  message: string;
}) {
  return <div className="flex min-h-[48px] w-[320px] max-w-[360px] items-center gap-[14px] rounded-sm border border-solid border-alternative bg-opacity-white-10 py-sm pl-lg pr-xl shadow-lg backdrop-blur-[2px]" data-sentry-component="QuoteRestrictionToast" data-sentry-source-file="QuoteRestrictionToast.tsx">
      <ExclamationmarkSmallCircleColorIcon size="md" className="shrink-0" data-sentry-element="ExclamationmarkSmallCircleColorIcon" data-sentry-source-file="QuoteRestrictionToast.tsx" />
      <span className="text-body-lg-semibold text-default">{message}</span>
    </div>;
}
export const showQuoteRestrictionToast = (message: string) => toast.custom(<QuoteRestrictionToast message={message} />, {
  position: 'top-right',
  duration: TOAST_DURATION
});